/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @next/next/no-img-element */
// libraries
import Link from 'next/link';
import { capitalizeWords, isColorLight, montaLinks } from '../../../utils/FunctionsGlobals';
import { appendCodsiteQuery } from '../../../utils/url';
// utils
import styles from './Popular.module.css';

const Popular: React.FC<{
    site: any;
    allRodape: any;
    codsite?: any;
    origin?: any;
}> = ({ site, allRodape, codsite, origin }) => {
    const cor_fundo5 = isColorLight(site?.cor5) ? site?.cor11 : site?.cor13;
    const withCodsite = (href: string) => appendCodsiteQuery(href, codsite, origin);

    // useState
    const allRodape1 = allRodape;
    const allLinks = allRodape1?.length > 0 ? montaLinks(allRodape1) : []

    return (
        <>
            {allLinks?.length > 0 ? (
                <div className={styles.mais_populares} style={{background: site?.cor5}}>
                    <div className={styles.pequisa_popular} style={{color: cor_fundo5}}>{site?.id == 2456 ? "PESQUISAS RECENTES" : site?.id == 1630 ? "PESQUISAS FREQUENTES" : site?.id == 2098 ? "PESQUISAS MAIS ACESSADAS" : "PESQUISAS MAIS POPULARES"}</div>
                    <ul className={styles.mais_buscados}>
                        {(allLinks?.length > 0 ? allLinks : [])
                            ?.slice(0, 17)
                            ?.map((v: any, cont: number) => (
                                <li className={styles.buscados} key={cont} style={{color: cor_fundo5, border: `1px solid ${cor_fundo5}`}}>
                                    <Link prefetch={false} href={withCodsite(v?.url)} passHref>
                                        <div
                                            title={v?.title}
                                        >
                                            {capitalizeWords(v?.title.toLowerCase()).replaceAll("Em ","em ")}
                                        </div>
                                    </Link>
                                </li>
                        ))}
                    </ul>
                </div>
            ) : null}
        </>
    );
};

export default Popular;
